import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

/**
 * The author's applications this one can be combined with — their own, to
 * competitions on overlapping dates; this one first (5 Oct 2026). Resolves
 * with the list, or [] on a failure already reported.
 */
export const fetchCombinableApplications = applicationId => dispatch => axios(apiRequestOptions(
    apiPath.REPORTS.APPLICATION_COMBINABLE,
    null,
    { params: { id: applicationId } },
))
    .then(transformHttpResponse)
    .then(response => response.data || [])
    .catch(error => transformHttpResponse(error.response))
    .catch(error => {
        dispatch(errorRequestHandler(error));

        return [];
    });

/** One PDF for this application and the ones named — fees counted across all of them. */
export const downloadCombinedApplication = (applicationId, withIds) => dispatch => axios({
    ...apiRequestOptions(apiPath.REPORTS.APPLICATION_COMBINED, null, { params: { id: applicationId }, isBlob: true }),
    params: { with: withIds.join(',') },
})
    .then(transformHttpResponse)
    .then(response => {
        const disposition = response.headers['content-disposition'] || '';
        const match = disposition.match(/filename="?([^";\s]+)"?/);
        download(response.data, match ? match[1] : 'combined_application.pdf', response.headers['content-type']);

        return true;
    })
    .catch(error => transformHttpResponse(error.response))
    .catch(error => {
        dispatch(errorRequestHandler(error));

        return false;
    });
